import React from 'react';
import { Main } from './components';

const Wallets = () => <Main />;

export default Wallets;
